import {
  Navbar,
  TalentVideocom,
  Experience,
  Footer,
  GalleryCom,
  HoverButton,
  InputField,
  Animatespin,
} from "../../components";
import GallerysBgColorsData from "../../js/gallerysBgColorsData";
import { IoClose } from "react-icons/io5";
import Icons from "../../assets/icon/index";
import { Link } from "react-router";
import ImageGallery from "react-image-gallery";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";
import Modal from "react-modal"; // or use your own modal
import Functions from "./index.function";

// ⭐ ADD THESE IMPORTS
import malePlaceholder from "../../assets/image/male.png";
import femalePlaceholder from "../../assets/image/female.png";
import bannerPlaceholder from "../../assets/image/gem bann web@3x.png";

Modal.setAppElement("#root"); // required for accessibility

// ⭐ ADD HELPER FUNCTION FOR GENDER-BASED PLACEHOLDERS
const getPlaceholderImage = (genderId) => {
  const parsedGenderId = parseInt(genderId);
  
  if (parsedGenderId === 1) {
    return femalePlaceholder; // Female
  } else if (parsedGenderId === 2) {
    return malePlaceholder; // Male
  } else {
    return malePlaceholder; // Default
  }
};

const Portfolio = () => {
  const {
    isLoading,
    portfolio,
    userData,
    isLoggedIn,
    navigate,
    setShowForm,
    showForm,
    setLoadingapi,
    mutationFavouritelike,
    refetch,
    localimgpath,
    openGallery,
    closeGallery,
    isOpen,
    galleryImages,
    selectedIndex,
    success,
    setsuccess,
    control,
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    loadingToapi,
    columns,
  } = Functions();

  return (
    <div className="bg-primary">
      <div className="relative">
        <div className="absolute top-0 left-0 w-full z-10">
          <Navbar />
          {isLoading ? (
            <Animatespin />
          ) : (
            <div className="flex justify-between items-center lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto pt-20">
              <div>
                <div>
                  <h1 className="uppercase text-secondary font-unboundedBold lg:text-5xl lg:leading-tight distant">
                    {portfolio?.real_name.split(" ")[0]} <br />{" "}
                    {portfolio?.real_name.split(" ")[1]}
                  </h1>
                </div>
                <div>
                  <p className="text-secondary font-onestMedium lg:text-xl">
                    {portfolio?.desired_job_types
                      ?.filter(job => job?.title)
                      .map(job => job.title)
                      .join(' • ')
                    }
                  </p>
                </div>
              </div>
              
              {/* ⭐ UPDATED: Hero Image with Placeholder */}
              <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-[#D4AF37] shadow-lg">
                <img
                  src={
                    portfolio?.hero_image
                      ? `${localimgpath?.talentThumbnail}/${portfolio?.hero_image}`
                      : getPlaceholderImage(portfolio?.gender_id)
                  }
                  alt={portfolio?.stage_name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          )}
        </div>
        
        {/* ⭐ UPDATED: Banner with Placeholder */}
        <div className="w-full relative">
          <img
            className="w-full"
            src={
              portfolio?.banner && portfolio?.banner.trim()
                ? `${localimgpath?.talentBanner}/${portfolio?.banner}`
                : bannerPlaceholder
            }
            alt={portfolio?.real_name || "Banner"}
          />
          
          {/* Show overlay text if no banner */}
          {/* {(!portfolio?.banner || !portfolio?.banner.trim()) && (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
              <p className="text-secondary font-onestSemiBold text-xl lg:text-3xl">
                No Banner Image
              </p>
            </div>
          )} */}
        </div>
      </div>
      
      {/* Rest of the component remains the same */}
      <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:pt-7 sm:py-12 lg:pt-16 text-white">
        <div className="flex justify-between items-center">
          <h2 className="text-secondary font-unboundedMedium text-sm sm:text-base capitalize lg:text-3xl lg:mb-3">
            {portfolio?.real_name} Info
          </h2>
          <div className="flex items-center xs:gap-2 sm:gap-3 lg:gap-4">
            {userData?.role === "talent" ? (
              ""
            ) : (
              <div className="hidden sm:block">
                <HoverButton
                  onClick={() => {
                    if (!isLoggedIn) {
                      navigate("/login");
                    } else if (!userData?.employer?.user_id) {
                      navigate("/upgrade");
                    } else {
                      setShowForm(true);
                    }
                  }}
                  extraClasses={
                    "group xs:w-44 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md xs:mr-2 mr-5"
                  }
                  BtnTitle={"Hire Me"}
                  BtnTitleClasses={
                    "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                  }
                />
              </div>
            )}
            <div
              onClick={() => {
                if (!isLoggedIn) {
                  navigate("/login");
                } else if (portfolio?.id === userData?.talent?.id) {
                  return null;
                } else {
                  setLoadingapi(true);
                  const userId = localStorage.getItem("userId");
                  mutationFavouritelike.mutate(
                    {
                      instance_id: portfolio?.id,
                      instance_type: "talent",
                      user_id: userId,
                      record_type: "Like",
                    },
                    {
                      onSettled: () => {
                        refetch();
                      },
                    }
                  );
                }
              }}
            >
              <img
                className={`xs:w-5 sm:w-6 lg:w-8 cursor-pointer transition-transform duration-200 ${
                  portfolio?.id === userData?.talent?.id
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:scale-110"
                }`}
                src={
                  portfolio?.is_like ? Icons.LiveActitveIcon : Icons.LiveIcon
                }
                alt={
                  portfolio?.is_like ? Icons.LiveActitveIcon : Icons.LiveIcon
                }
              />
            </div>
            <div
              onClick={() => {
                if (!isLoggedIn) {
                  navigate("/login");
                } else if (portfolio?.id === userData?.talent?.id) {
                  return null;
                } else {
                  setLoadingapi(true);
                  const userId = localStorage.getItem("userId");
                  mutationFavouritelike.mutate(
                    {
                      instance_id: portfolio?.id,
                      instance_type: "talent",
                      user_id: userId,
                      record_type: "Favourite",
                    },
                    {
                      onSettled: () => {
                        refetch();
                      },
                    }
                  );
                }
              }}
            >
              <img
                className={`xs:w-5 sm:w-6 lg:w-8 cursor-pointer transition-transform duration-200 ${
                  portfolio?.id === userData?.talent?.id
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:scale-110"
                }`}
                src={
                  portfolio?.is_favourite ? Icons.favAvtiveIcon : Icons.favIcon
                }
                alt={
                  portfolio?.is_favourite ? Icons.favAvtiveIcon : Icons.favIcon
                }
              />
            </div>
          </div>
        </div>
        {userData?.role === "talent" ? (
          ""
        ) : (
          <div className="block my-4 sm:hidden">
            <HoverButton
              onClick={() => {
                if (!isLoggedIn) {
                  navigate("/login");
                } else if (!userData?.employer?.user_id) {
                  navigate("/upgrade");
                } else {
                  setShowForm(true);
                }
              }}
              extraClasses={
                "group xs:w-44 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md xs:mr-2 mr-5"
              }
              BtnTitle={"Hire Me"}
              BtnTitleClasses={
                "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
              }
            />
          </div>
        )}

        <div className="flex flex-wrap justify-between sm:pt-12">
          {columns.map((col, colIndex) => (
            <div key={colIndex} className="w-full sm:w-4/12">
              {col.map((info, index) => (
                <div key={index} className="flex py-2">
                  <span className="font-onestSemiBold lg:text-sm xl:text-xl text-secondary xs:w-32 sm:w-32 lg:w-32 xl:w-5/12">
                    {info?.title}
                  </span>
                  <span className="font-onestRegular lg:text-sm xl:text-xl text-secondary xs:w-11/12 sm:w-9/12 xl:w-7/12">
                    {info?.value}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>

        <div
          className={`flex justify-center items-center pt-5 sm:pt-6 lg:pt-10 ${
            isLoggedIn ? "hidden" : "block"
          }`}
          onClick={() => navigate("/login")}
        >
          <HoverButton
            extraClasses={
              "group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
            }
            BtnTitle={"See More"}
            BtnTitleClasses={
              "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
            }
          />
        </div>
        {isLoggedIn && (
          <>
            {portfolio?.about_me &&
            portfolio.about_me.trim().toLowerCase() !== "null" &&
            portfolio.about_me.trim().toLowerCase() !== "undefined" ? (
              <div className="lg:pt-20">
                <h2 className="text-secondary font-unboundedMedium text-sm sm:text-base lg:text-3xl lg:mb-8">
                  About {portfolio?.real_name}
                </h2>
                <p className="text-secondary font-onestLight xs:mb-1 xs:text-xs sm:text-xs xl:mb-4 lg:mb-2 sm:mb-2 xl:text-base lg:text-sm ">
                  {portfolio?.about_me}
                </p>
              </div>
            ) : null}

            {portfolio?.social_media && portfolio.social_media.length > 0 && (
              <div className="pb-6 sm:pt-12">
                <h2 className="text-secondary font-unboundedMedium text-sm sm:text-base lg:text-3xl lg:mb-8">
                  Social Media
                </h2>
                <div className="flex flex-wrap gap-4">
                  {portfolio.social_media
                    .filter(social => social?.social_media_link && social?.social_media_type)
                    .map((social, index) => {
                      // Get platform icon based on type
                      const getPlatformIcon = (type) => {
                        const platformKey = type.toLowerCase();
                        
                        const icons = {
                          facebook: (
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                            </svg>
                          ),
                          instagram: (
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                            </svg>
                          ),
                          linkedin: (
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                            </svg>
                          ),
                          tiktok: (
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                            </svg>
                          ),
                          youtube: (
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                            </svg>
                          ),
                        };
                        
                        return icons[platformKey] || (
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                          </svg>
                        );
                      };

                      return (
                        <a
                          key={index}
                          href={social.social_media_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group flex items-center gap-2 bg-secondary/10 hover:bg-goldMetallic/20 
                                    transition-all duration-300 px-4 py-2 rounded-full border 
                                    border-secondary/20 hover:border-goldMetallic hover:scale-105"
                          title={`${social.social_media_type} Profile`}
                        >
                          <span className="text-goldMetallic group-hover:text-white transition-colors">
                            {getPlatformIcon(social.social_media_type)}
                          </span>
                          
                          <span className="text-secondary group-hover:text-goldMetallic font-onestMedium xs:text-xs sm:text-sm lg:text-base">
                            {social.social_media_type}
                          </span>
                        </a>
                      );
                    })}
                </div>
              </div>
            )}

            {/* Gallery section - make sure this is right after the social media closing */}
            {portfolio?.galleries?.length > 0 && (
              <div className="pb-6 sm:pt-12">
                {/* Your gallery code here */}
              </div>
            )}


            {portfolio?.galleries?.length > 0 && (
              <div className="pb-6 sm:pt-12">
                <h2 className="text-secondary font-unboundedMedium text-sm sm:text-base lg:text-3xl">
                  Gallery
                </h2>
                <div className="xs:mt-5 sm:mt-8 grid xs:grid-cols-2 sm:grid-cols-5 xs:gap-7 sm:gap-4 lg:gap-5 xl:gap-14">
                  {portfolio?.galleries?.map((Item, index) => (
                    <div
                      key={index}
                      onClick={() => openGallery(index)}
                      className="cursor-pointer"
                    >
                      <GalleryCom
                        latestNewsthubmail={`${localimgpath?.talentGallery}/${Item?.image}`}
                        alt={Item?.title || "Gallery Image"}
                        layout={
                          "xs:w-32 xs:h-32 sm:w-[140px] sm:h-[140px] lg:w-[180px] lg:h-[180px] xl:w-[200px] xl:h-[200px] 2xl:w-[240px] 2xl:h-[240px]  2xl-wide:w-[256px] 2xl-wide:h-[256px] rounded-full"
                        }
                        Img={"w-[95%] h-[95%] rounded-full"}
                        bgcolor={
                          GallerysBgColorsData[
                            index % GallerysBgColorsData?.length
                          ]?.gallerybgcolor
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Modal with ImageGallery */}
            <Modal
              isOpen={isOpen}
              onRequestClose={closeGallery}
              contentLabel="Image Gallery Modal"
              className="w-full mx-0 sm:mx-auto p-4 sm:p-6 bg-primary rounded-lg shadow-xl overflow-y-auto"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            >
              <button
                onClick={closeGallery}
                className="absolute top-2 right-2 text-white text-xl z-10"
              >
                ✕
              </button>

              <ImageGallery
                items={galleryImages}
                startIndex={selectedIndex}
                showPlayButton={false}
                showFullscreenButton={true}
                showThumbnails={true}
                showIndex={true}
              />
            </Modal>

            {portfolio?.dramas?.length === 0 ? (
              <></>
            ) : (
              <div className="pb-6 sm:py-12">
                <h2 className="text-secondary font-unboundedMedium text-sm sm:text-base lg:text-3xl">
                  Projects
                </h2>
                <div className="xs:mt-5 sm:mt-8 grid xs:grid-cols-2 sm:grid-cols-5 xs:gap-7 sm:gap-4 lg:gap-5 xl:gap-14">
                  {portfolio?.dramas?.map((value, index) => (
                    <div key={`${index}`}>
                      <div key={index}>
                        <Link
                          to={value.external_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <GalleryCom
                            latestNewsthubmail={`${localimgpath?.talentDrama}/${value?.image}`}
                            layout={
                              " xs:h-48 sm:h-60 lg:h-96 rounded-[20px] p-1 sm:p-1.5"
                            }
                            Img={"w-full h-full rounded-[20px]"}
                            bgcolor={
                              GallerysBgColorsData[
                                index % GallerysBgColorsData?.length
                              ]?.dramascolor
                            }
                          />
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {portfolio?.videos?.length === 0 ? (
              // <p className="text-secondary">No videos data</p>
              <></>
            ) : (
              <div className="pb-6 sm:py-12">
                <h2 className="text-secondary font-unboundedMedium text-sm sm:text-base lg:text-3xl">
                  Videos
                </h2>
                <div className="xs:mt-5 sm:mt-8 grid xs:grid-cols-2 sm:grid-cols-5 xs:gap-7 sm:gap-4 lg:gap-5 xl:gap-14">
                  {portfolio?.videos?.map((value, index) => (
                    <div key={`${index}`}>
                      <div key={index}>
                        <Link
                          to={value.external_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <TalentVideocom
                            eventthubmail={`${localimgpath?.talentVideo}/${value?.image}`}
                            eventtheme={
                              GallerysBgColorsData[
                                index % GallerysBgColorsData?.length
                              ]?.videoscolor
                            }
                            eventTitle={value.title}
                            eventDis={value.eventDis}
                          />
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <div className="m-auto xs:py-5">
        <Experience />
      </div>
      <Footer />
      {showForm && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#0d0d0def] flex justify-center items-center xs:p-5 sm:p-10 lg:p-16 z-40">
          <div className="xs:w-full sm:w-[85%] lg:w-[80%] xl:w-[60%] bg-[#151515] rounded-3xl h-full relative ">
            <div
              className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 absolute -top-1 -right-1 rounded-full bg-goldMetallic cursor-pointer transform transition-transform duration-300 hover:scale-110"
              onClick={() => setShowForm(false)}
            >
              <IoClose className="text-secondary group-hover:text-primary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
            </div>
            <form
              className="flex flex-col flex-1 h-full lg:px-2"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="xs:p-5 sm:p-8 lg:p-10">
                <h2 className="text-secondary font-unboundedBold lg:text-xl">
                  Detail Form
                </h2>
              </div>
              <div className="flex-1 overflow-y-auto scroll-container xs:px-5 sm:px-8 lg:px-10">
                <div className="relative">
                  <InputField
                    control={control}
                    errors={errors}
                    label="Project Title"
                    type="text"
                    name="projectTitle"
                    {...register("projectTitle", {
                      required: "Project Title is required",
                    })}
                    onChange={(value) => setValue("projectTitle", value)}
                    isMandatory={true}
                  />
                </div>
                <div className="xs:py-2 sm:py-3 lg:py-4">
                  <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center">
                    <p className="xs:text-lg lg:text-lg font-josefinSansRegular text-secondary">
                      Description
                    </p>
                    <p className="text-errorRed pl-2 text-lg leading-3">
                      {"*"}
                    </p>
                  </div>
                  <div className="xs:h-36 sm:h-40 lg:h-40">
                    <textarea
                      className="xs:px-5 xs:text-[15px] mb-1 px-5 bg-[#171717] text-[16px] font-josefinSansRegular w-full py-4 h-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic rounded-3xl "
                      name="description"
                      placeholder="Type here..."
                      {...register("description", {
                        required: "Description is required",
                      })}
                      onChange={(e) => setValue("description", e.target.value)}
                    />
                    <div className="flex justify-start items-center xs:pl-6 sm:pl-6 lg:pl-8 xs:pt-[2px] sm:pt-1">
                      {errors.description && (
                        <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
                          {errors.description.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="relative mt-[18px]">
                  <InputField
                    control={control}
                    errors={errors}
                    label="Duration"
                    type="text"
                    name="duration"
                    {...register("duration", {
                      required: "Duration is required",
                    })}
                    onChange={(value) => setValue("duration", value)}
                    isMandatory={true}
                  />
                </div>
                <div className="relative mt-[18px]">
                  <InputField
                    control={control}
                    errors={errors}
                    label="Start Date"
                    type="date"
                    name="startDate"
                    cardIcon={Icons.calendarIcon}
                    {...register("startDate", {
                      required: "Start Date is required",
                    })}
                    onChange={(value) => setValue("startDate", value)}
                    isMandatory={true}
                  />
                </div>
                <div className="relative mt-[18px]">
                  <InputField
                    control={control}
                    errors={errors}
                    label="Budget"
                    type="text"
                    name="budget"
                    {...register("budget", { required: "Budget is required" })}
                    onChange={(value) => setValue("budget", value)}
                    isMandatory={true}
                  />
                </div>
              </div>
              <div className="flex justify-center flex-col items-center pt-2.5 pb-5 sm:pt-5 sm:pb-10">
                <HoverButton
                  extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform ${
                    loadingToapi ? "" : "hover:scale-105 hover:shadow-md"
                  } `}
                  type={"submit"}
                  disabled={loadingToapi}
                  BtnTitle={
                    loadingToapi ? (
                      <div className="flex justify-center items-center">
                        <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                      </div>
                    ) : (
                      "Submit"
                    )
                  }
                  BtnTitleClasses={
                    "transition-transform transform group-hover:scale-110 group-hover:text-primary"
                  }
                />
              </div>
            </form>
          </div>
        </div>
      )}
      {success && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#0d0d0def] flex justify-center items-center xs:p-5 sm:p-10 z-40">
          <div className="xs:w-[80%] sm:w-[45%] lg:w-[35%] 2xl:w-[26%] xl:w-1/3 bg-[#151515] xs:p-5 sm:p-8 rounded-3xl h-auto relative ">
            <div
              className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 absolute -top-1 -right-1 rounded-full bg-goldMetallic cursor-pointer transform transition-transform duration-300 hover:scale-110"
              onClick={() => setsuccess(false)}
            >
              <IoClose className="text-secondary group-hover:text-primary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
            </div>
            <div className="flex justify-center items-center flex-col xs:pt-14 sm:pt-16 lg:pt-20 xl:pt-24">
              <div className="text-center lg:pb-7 xl:pb-14">
                <h2 className="text-secondary font-josefinSansMedium xs:pb-2 sm:pb-3 lg:pb-5 xs:text-xl sm:text-2xl lg:text-3xl xl:text-4xl">
                  Congratulations
                </h2>
                <p className="text-secondary font-josefinSansLight xs:text-xs sm:text-xs lg:text-sm xl:text-base">
                  Your Application has been successfully submitted. You can
                  track the progress of your application through the application
                  menu.
                </p>
              </div>
              <div className="flex justify-center items-center my-10 lg:my-8">
                <HoverButton
                  onClick={() => navigate("/employer-hire-request")}
                  extraClasses={
                    "group xs:w-44 xs:h-10 sm:w-48 sm:h-10 xl:w-64 lg:w-52 cursor-pointer bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                  }
                  BtnTitle="Go To My Dashboard"
                  BtnTitleClasses={
                    "text-secondary font-onestMedium xs:text-sm sm:text-base lg:text-lg xl:text-xl transition-transform transform group-hover:scale-105 group-hover:text-primary"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Portfolio;